import { BaseURl } from "./BaseApiUrl";



//Nhttps://testcockpit.p2k.in/api/userdetails/repHistoricalCallBoardsRecords/v1/?userUUID=1d33299f-f015-11ee-91f2-b8ca3ad15bed&callType=3&isPagination=1&pageNo=1&perPageRec=200&historicDate=2026-02-16
export const getHistoricalCallBoardsRecordsAPIURL = BaseURl + "userdetails/repHistoricalCallBoardsRecords/v1/";
